var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoeurTrans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 354,
    height: 357,
    fill: "none",
    viewBox: "0 0 354 357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M277.741 8.807c-39.185-15.3-77.032-10.605-111.589 14.167-22.726 16.29-37.693 38.198-44.209 65.405-2.282 9.537-3.173 19.407-4.77 29.586.185-.062.075.006-.048.007-2.491.155-5.004.275-7.495.458-33.495 2.432-61.376 16.361-82.516 42.27C5.1 187.675-3.633 218.929 2.265 253.371c6.53 38.129 27.192 66.677 61.723 84.458 27.404 14.099 57.164 18.707 87.689 19.08 29.491.369 58.809-2.67 88.107-5.58 26.689-2.652 53.433-5.481 79.155-13.465 17.365-5.393 13.991-1.979 19.712-18.96 10.595-31.448 16.417-63.919 18.912-96.929 3.467-45.612 2.335-90.888-10.319-135.315-10.609-37.248-33.693-63.866-69.503-77.853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeurTrans);
export default __webpack_public_path__ + "static/media/CoeurTrans.db2727ea12e9f4089c5726e7f14e1075.svg";
export { ForwardRef as ReactComponent };